<div class="card mb-4">
  <table class="table mb-0">
    <thead class="table-header">
      <tr>
        <ng-container *ngTemplateOutlet="headersTpl() ?? null"></ng-container>
      </tr>
    </thead>
    <tbody>
      @for(formGroup of formArray().controls; track formGroup.value.id; let i =
      $index){
      <tr [formGroup]="formGroup" (ngSubmit)="onFormSubmit($event)">
        <ng-container
          *ngTemplateOutlet="
            rowTpl() ?? null;
            context: { $implicit: formGroup, index: i }
          "
        ></ng-container>
      </tr>
      }
    </tbody>
  </table>
  @if(canAdd()) {
  <div class="add-row">
    <button class="btn btn-outline-primary btn-sm" (click)="add.emit()">
      <span class="fas fa-plus"></span> {{ addButtonTitle() | translate }}
    </button>
  </div>
  }
</div>
